import { render, staticRenderFns } from "./imprest.vue?vue&type=template&id=2a2c0870&scoped=true"
import script from "./imprest.vue?vue&type=script&lang=js"
export * from "./imprest.vue?vue&type=script&lang=js"
import style0 from "./imprest.vue?vue&type=style&index=0&id=2a2c0870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c0870",
  null
  
)

export default component.exports